<div id="PNWrapper">

  <!-- Back Button -->
  <div class="backButton" (click)="builderService.navigateBack()">
    <img src="/assets/icons/arrow-left.svg" alt="Go back" />
  </div>

  <!-- Header Section -->
  <div class="header-section">
    <div class="header-info">
      <p class="title">{{ 'Push Notifications' | translate }}</p>
      <p class="subtitle">{{ 'Send notifications to your customers instantly.' | translate }}</p>
    </div>
    <div class="header-actions">
      <button type="button" class="btn-cancel" (click)="builderService.navigateBack()">{{ 'Cancel' | translate }}</button>
      <button type="button" class="btn-save" (click)="saveChanges()">{{ 'Save Configuration' | translate }}</button>
    </div>
  </div>

  <!-- Firebase Connection Card -->
  <div class="section-card" [formGroup]="PNForm">
    <div class="card-header">
      <h3>{{ 'Firebase Connection' | translate }}</h3>
      <div class="howItWorks noselect" (click)="howItWorksDialog()">
        <span class="material-icons-outlined">play_circle_filled</span>
        {{ 'How it works' | translate }}
      </div>
    </div>
    <div class="card-body">

      <!-- URL inputs row -->
      <div class="firebase-fields-row">
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Database URL' | translate }}</label>
            <a href="https://console.firebase.google.com/u/0/project/_/settings/serviceaccounts/adminsdk" target="_blank">
              {{ 'Get Firebase Service Keys' | translate }}
              <img src="assets/icons/External_link.svg" alt="External link" />
            </a>
          </div>
          <div class="genie-input">
            <input formControlName="databaseURL" placeholder="https://your-project-id.firebaseio.com" type="text" />
          </div>
        </div>
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Android Sender ID' | translate }}</label>
            <a href="https://console.firebase.google.com/u/0/project/_/settings/cloudmessaging/android" target="_blank">
              {{ 'Get Android Config Files' | translate }}
              <img src="assets/icons/External_link.svg" alt="External link" />
            </a>
          </div>
          <div class="genie-input">
            <input formControlName="googleSenderId" placeholder="{{ 'Android Sender ID' | translate }}" type="text" />
          </div>
        </div>
      </div>

      <!-- Upload areas -->
      <div class="upload-grid">

        <!-- Firebase Service Keys -->
        <div class="upload-item">
          <div class="label-row">
            <label>{{ 'Firebase Service Keys' | translate }}</label>
          </div>
          <div class="upload-area" [class.has-file]="serviceAccountFile">
            <input type="file" formControlName="serviceAccountKeys" id="service_account_keys" name="service_account_keys" accept="*" (change)="processFile($event, 'application/octet-stream', 'serviceAccountKeys')" />
            <ng-container *ngIf="serviceAccountFile; else uploadServiceKey">
              <div class="file-icon-wrap">
                <svg width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 1H4C2.89543 1 2 1.89543 2 3V25C2 26.1046 2.89543 27 4 27H20C21.1046 27 22 26.1046 22 25V9L14 1Z" fill="#ECF5F8" stroke="#388CA9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14 1V9H22" stroke="#388CA9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M16 15H8M16 19H8M10 11H8" stroke="#388CA9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <p class="uploaded-file-name">{{ serviceAccountFileName }}</p>
              <button type="button" class="remove-file" (click)="removeFile('serviceAcc')">
                <svg width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.75 3.5H12.25M5.25 6.125V10.375M8.75 6.125V10.375M2.625 3.5L3.5 11.375C3.5 11.8391 3.68437 12.2842 4.01256 12.6124C4.34075 12.9406 4.78587 13.125 5.25 13.125H8.75C9.21413 13.125 9.65925 12.9406 9.98744 12.6124C10.3156 12.2842 10.5 11.8391 10.5 11.375L11.375 3.5M4.375 3.5V1.75C4.375 1.51794 4.46719 1.29538 4.63128 1.13128C4.79538 0.967187 5.01794 0.875 5.25 0.875H8.75C8.98206 0.875 9.20462 0.967187 9.36872 1.13128C9.53281 1.29538 9.625 1.51794 9.625 1.75V3.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                {{ 'Delete' | translate }}
              </button>
            </ng-container>
            <ng-template #uploadServiceKey>
              <div class="upload-icon-circle">
                <svg width="40" height="40" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="3.33301" y="3.33398" width="40" height="40" rx="20" fill="#ECF5F8" />
                  <path d="M20 26.6673L23.3333 23.334M23.3333 23.334L26.6667 26.6673M23.3333 23.334V30.834M30 27.2863C31.0179 26.4457 31.6667 25.1739 31.6667 23.7507C31.6667 21.2193 29.6146 19.1673 27.0833 19.1673C26.9012 19.1673 26.7309 19.0723 26.6384 18.9154C25.5517 17.0713 23.5454 15.834 21.25 15.834C17.7982 15.834 15 18.6322 15 22.084C15 23.8057 15.6962 25.3649 16.8225 26.4953" stroke="#388CA9" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="upload-text">{{ 'click to Upload' | translate }}</div>
              <div class="upload-hint">{{ 'Admin SDK service account JSON file' | translate }}</div>
            </ng-template>
          </div>
        </div>

        <!-- Google Service JSON -->
        <div class="upload-item">
          <div class="label-row">
            <label>{{ 'Google Service JSON' | translate }}</label>
          </div>
          <div class="upload-area" [class.has-file]="jsonFile">
            <input type="file" formControlName="googleServiceJson" id="google_service_json" name="google_service_json" accept="application/JSON" (change)="processFile($event, 'application/json', 'googleServiceJson')" />
            <ng-container *ngIf="jsonFile; else uploadJson">
              <div class="file-icon-wrap">
                <svg width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 1H4C2.89543 1 2 1.89543 2 3V25C2 26.1046 2.89543 27 4 27H20C21.1046 27 22 26.1046 22 25V9L14 1Z" fill="#ECF5F8" stroke="#388CA9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14 1V9H22" stroke="#388CA9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M16 15H8M16 19H8M10 11H8" stroke="#388CA9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <p class="uploaded-file-name">{{ jsonFileName }}</p>
              <button type="button" class="remove-file" (click)="removeFile('jsonFile')">
                <svg width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.75 3.5H12.25M5.25 6.125V10.375M8.75 6.125V10.375M2.625 3.5L3.5 11.375C3.5 11.8391 3.68437 12.2842 4.01256 12.6124C4.34075 12.9406 4.78587 13.125 5.25 13.125H8.75C9.21413 13.125 9.65925 12.9406 9.98744 12.6124C10.3156 12.2842 10.5 11.8391 10.5 11.375L11.375 3.5M4.375 3.5V1.75C4.375 1.51794 4.46719 1.29538 4.63128 1.13128C4.79538 0.967187 5.01794 0.875 5.25 0.875H8.75C8.98206 0.875 9.20462 0.967187 9.36872 1.13128C9.53281 1.29538 9.625 1.51794 9.625 1.75V3.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                {{ 'Delete' | translate }}
              </button>
            </ng-container>
            <ng-template #uploadJson>
              <div class="upload-icon-circle">
                <svg width="40" height="40" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="3.33301" y="3.33398" width="40" height="40" rx="20" fill="#ECF5F8" />
                  <path d="M20 26.6673L23.3333 23.334M23.3333 23.334L26.6667 26.6673M23.3333 23.334V30.834M30 27.2863C31.0179 26.4457 31.6667 25.1739 31.6667 23.7507C31.6667 21.2193 29.6146 19.1673 27.0833 19.1673C26.9012 19.1673 26.7309 19.0723 26.6384 18.9154C25.5517 17.0713 23.5454 15.834 21.25 15.834C17.7982 15.834 15 18.6322 15 22.084C15 23.8057 15.6962 25.3649 16.8225 26.4953" stroke="#388CA9" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="upload-text">{{ 'click to Upload' | translate }}</div>
              <div class="upload-hint">{{ 'Android configuration file (google-services.json)' | translate }}</div>
            </ng-template>
          </div>
        </div>

        <!-- Google Service Plist -->
        <div class="upload-item">
          <div class="label-row">
            <label>{{ 'Google Service Plist' | translate }}</label>
          </div>
          <div class="upload-area" [class.has-file]="plistFile">
            <input type="file" formControlName="googleServicePlist" id="google_service_plist" name="google_service_plist" accept="*" (change)="processFile($event, 'application/octet-stream', 'googleServicePlist')" />
            <ng-container *ngIf="plistFile; else uploadPlist">
              <div class="file-icon-wrap">
                <svg width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 1H4C2.89543 1 2 1.89543 2 3V25C2 26.1046 2.89543 27 4 27H20C21.1046 27 22 26.1046 22 25V9L14 1Z" fill="#ECF5F8" stroke="#388CA9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14 1V9H22" stroke="#388CA9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M16 15H8M16 19H8M10 11H8" stroke="#388CA9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <p class="uploaded-file-name">{{ plistFileName }}</p>
              <button type="button" class="remove-file" (click)="removeFile('plistFile')">
                <svg width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.75 3.5H12.25M5.25 6.125V10.375M8.75 6.125V10.375M2.625 3.5L3.5 11.375C3.5 11.8391 3.68437 12.2842 4.01256 12.6124C4.34075 12.9406 4.78587 13.125 5.25 13.125H8.75C9.21413 13.125 9.65925 12.9406 9.98744 12.6124C10.3156 12.2842 10.5 11.8391 10.5 11.375L11.375 3.5M4.375 3.5V1.75C4.375 1.51794 4.46719 1.29538 4.63128 1.13128C4.79538 0.967187 5.01794 0.875 5.25 0.875H8.75C8.98206 0.875 9.20462 0.967187 9.36872 1.13128C9.53281 1.29538 9.625 1.51794 9.625 1.75V3.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                {{ 'Delete' | translate }}
              </button>
            </ng-container>
            <ng-template #uploadPlist>
              <div class="upload-icon-circle">
                <svg width="40" height="40" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="3.33301" y="3.33398" width="40" height="40" rx="20" fill="#ECF5F8" />
                  <path d="M20 26.6673L23.3333 23.334M23.3333 23.334L26.6667 26.6673M23.3333 23.334V30.834M30 27.2863C31.0179 26.4457 31.6667 25.1739 31.6667 23.7507C31.6667 21.2193 29.6146 19.1673 27.0833 19.1673C26.9012 19.1673 26.7309 19.0723 26.6384 18.9154C25.5517 17.0713 23.5454 15.834 21.25 15.834C17.7982 15.834 15 18.6322 15 22.084C15 23.8057 15.6962 25.3649 16.8225 26.4953" stroke="#388CA9" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="upload-text">{{ 'click to Upload' | translate }}</div>
              <div class="upload-hint">{{ 'iOS configuration file (GoogleService-Info.plist)' | translate }}</div>
            </ng-template>
          </div>
        </div>

      </div>


    </div>
  </div>

  <!-- Compose Notification Card -->
  <div class="section-card">
    <div class="card-header">
      <h3>{{ 'Compose Notification' | translate }}</h3>
    </div>
    <div class="card-body" [formGroup]="PNForm">

      <div class="compose-layout">

        <!-- Left: Form + Table -->
        <div class="compose-left">

          <!-- Unified grid: [Title | Link Type | Message↕] / [Product | Standalone | Message↕] -->
          <div class="compose-form-grid">

            <div class="field-wrapper">
              <div class="field-label-row"><label>{{ 'Title' | translate }}</label></div>
              <div class="genie-input">
                <input formControlName="title" placeholder="{{ 'notification Title' | translate }}" max-length="65" value="{{ this.PNForm.value.title }}" (keyup)="characterCounter('title')" />
              </div>
            </div>

            <div class="field-wrapper">
              <div class="field-label-row"><label>{{ 'Link Type' | translate }}</label></div>
              <div class="pn-custom-select" (click)="toggleDropdown('route', $event)">
                <span [class.select-placeholder]="!PNForm.get('route')?.value" class="select-value">
                  {{ PNForm.get('route')?.value ? (getRouteLabel(PNForm.get('route')?.value) | translate) : ('Select' | translate) }}
                </span>
                <img src="/assets/icons/arrow-down.svg" width="14" height="14" alt="" class="select-arrow" [class.open]="dropdownOpen['route']" />
              </div>
              <div class="pn-dropdown-panel" *ngIf="dropdownOpen['route']" (click)="$event.stopPropagation()">
                <div class="pn-dropdown-option" *ngFor="let opt of routeOptions" [class.selected]="PNForm.get('route')?.value === opt.value" (click)="selectOption('route', 'route', opt.value, $event)">
                  {{ opt.label | translate }}
                </div>
                <div class="pn-dropdown-option" *ngFor="let customView of builderService.getCustomViews()" [class.selected]="PNForm.get('route')?.value === customView.view_name" (click)="selectOption('route', 'route', customView.view_name, $event)">
                  {{ customView.view_name }}
                </div>
              </div>
            </div>

            <!-- Message — right column, spans both rows -->
            <div class="field-wrapper message-field">
              <div class="field-label-row"><label>{{ 'Message' | translate }}</label></div>
              <div class="genie-input textarea-field">
                <textarea formControlName="message" placeholder="{{ 'Write your notification message...' | translate }}" max-length="240" (keyup)="characterCounter('message')">{{ this.PNForm.value.message }}</textarea>
              </div>
              <span class="characterCounter" [ngClass]="messageClass">{{ messageCounter }} {{ 'Characters Left' | translate }}</span>
            </div>

            <div class="field-wrapper">
              <div class="field-label-row"><label>{{ 'Product' | translate }}</label></div>
              <div class="pn-custom-select" (click)="toggleDropdown('product', $event)">
                <span [class.select-placeholder]="!getProductLabel(PNForm.get('specificRoute')?.value)" class="select-value">
                  {{ getProductLabel(PNForm.get('specificRoute')?.value) || ('-- Select Product --' | translate) }}
                </span>
                <img src="/assets/icons/arrow-down.svg" width="14" height="14" alt="" class="select-arrow" [class.open]="dropdownOpen['product']" />
              </div>
              <div class="pn-dropdown-panel" *ngIf="dropdownOpen['product']" (click)="$event.stopPropagation()">
                <div class="pn-dropdown-option" *ngFor="let product of storedProducts" [class.selected]="PNForm.get('specificRoute')?.value == product.id" (click)="selectOption('product', 'specificRoute', product.id, $event)">
                  {{ product.name }}
                </div>
              </div>
            </div>

            <div class="field-wrapper">
              <div class="field-label-row"><label>{{ 'Standalone Product' | translate }}</label></div>
              <div class="pn-custom-select" (click)="toggleDropdown('standalone', $event)">
                <span [class.select-placeholder]="!getStandaloneProductLabel(PNForm.get('specificRoute')?.value)" class="select-value">
                  {{ getStandaloneProductLabel(PNForm.get('specificRoute')?.value) || ('-- Select Product --' | translate) }}
                </span>
                <img src="/assets/icons/arrow-down.svg" width="14" height="14" alt="" class="select-arrow" [class.open]="dropdownOpen['standalone']" />
              </div>
              <div class="pn-dropdown-panel" *ngIf="dropdownOpen['standalone']" (click)="$event.stopPropagation()">
                <div class="pn-dropdown-option" *ngFor="let product of standaloneProductsService.storedStandaloneProducts" [class.selected]="PNForm.get('specificRoute')?.value == (product.Id || product.product_id)" (click)="selectOption('standalone', 'specificRoute', product.Id || product.product_id, $event)">
                  {{ product.productName }}
                </div>
              </div>
            </div>

          </div>

          <!-- User List -->
          <div class="user-list-section">

            <!-- Toolbar -->
            <div class="genie-toolbar">
              <div class="toolbar-left">
                <h4 class="user-list-title">{{ 'User List' | translate }}</h4>
              </div>
              <div class="toolbar-right">
                <form (ngSubmit)="onSubmit()" class="pn-search-form">
                  <div class="search-input-wrapper">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5.75 10.5C8.37335 10.5 10.5 8.37335 10.5 5.75C10.5 3.12665 8.37335 1 5.75 1C3.12665 1 1 3.12665 1 5.75C1 8.37335 3.12665 10.5 5.75 10.5Z" stroke="#ADADAD" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M11 11L10 10" stroke="#ADADAD" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <input type="text" placeholder="{{ 'Search...' | translate }}" [(ngModel)]="searchKey" name="search" />
                  </div>
                  <button type="submit" class="genie-btn secondary">{{ 'Search user' | translate }}</button>
                </form>
                <button class="genie-btn primary" id="sendPushNotifications" (click)="sendMessage()">
                  <span *ngIf="!this.mobile">{{ 'Send' | translate }}</span>
                  <svg *ngIf="this.mobile" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 6L9 17L4 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
              </div>
            </div>

            <!-- Table -->
            <div class="genie-table-wrapper">
              <div class="genie-table-scroll">
              <table class="genie-table">
                <thead>
                  <tr>
                    <th class="col-checkbox">
                      <label class="pn-check">
                        <input type="checkbox" [checked]="allChecked" (click)="checked('all')" />
                        <span class="check-box">
                          <svg class="check-icon" width="9" height="7" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 3L3.5 5.5L8 1" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </span>
                      </label>
                    </th>
                    <th class="col-name">{{ 'Name' | translate }}</th>
                    <th class="col-email">{{ 'Email' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let element of pagedUsers" [class.selected-row]="element.isChecked">
                    <td class="col-checkbox">
                      <label class="pn-check">
                        <input type="checkbox" [checked]="element.isChecked" (click)="checked(element)" />
                        <span class="check-box">
                          <svg class="check-icon" width="9" height="7" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 3L3.5 5.5L8 1" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </span>
                      </label>
                    </td>
                    <td class="col-name">{{ element.name }}</td>
                    <td class="col-email">{{ element.email }}</td>
                  </tr>
                  <tr *ngIf="!pagedUsers?.length" class="empty-row">
                    <td colspan="3">{{ 'No users found.' | translate }}</td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>

            <!-- Hidden paginator (pagination state logic) -->
            <mat-paginator #pnPaginator [length]="length" [pageSize]="5" aria-label="Select page" class="hidden-paginator"></mat-paginator>

            <!-- Custom pagination UI -->
            <div class="genie-pagination">
              <div class="pagination-pageSize">
                <span class="pageSize-label">{{ 'Items per page' | translate }}:</span>
                <span class="pageSize-value">5</span>
              </div>
              <div class="pagination-info">
                <span class="current-page">{{ pnPaginator.pageIndex + 1 }}</span>
                <span class="page-separator">{{ 'of' | translate }}</span>
                <span class="total-pages">{{ pnPaginator.getNumberOfPages() || 1 }}</span>
              </div>
              <div class="pagination-controls">
                <button class="page-btn prev" (click)="pnPaginator.previousPage()" [disabled]="!pnPaginator.hasPreviousPage()">
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.25 7.5L3.75 5L6.25 2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>
                <button class="page-btn next" (click)="pnPaginator.nextPage()" [disabled]="!pnPaginator.hasNextPage()">
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.75 7.5L6.25 5L3.75 2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            </div>

          </div>

        </div>

        <!-- Right: Phone Preview -->
        <div class="phone-preview-wrapper">
          <div class="phone-preview">
            <div class="currentTime">
              <h2>{{ formattedDate }}</h2>
              <h2 class="time">{{ formattedTime }}</h2>
            </div>
            <div id="PNPreview">
              <div id="PNTitlePreview">
                <span *ngIf="!this.PNForm.value.title">{{ 'Awesome Offer' | translate }}</span>{{ this.PNForm.value.title }}
                <h2>{{ 'now' | translate }}</h2>
              </div>
              <div id="PNMessagePreview">
                <span *ngIf="!this.PNForm.value.message">{{ 'An offer that you can\'t miss' | translate }}</span>{{ this.PNForm.value.message }}
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

</div>
<form [formGroup]="PNForm" id="PNForm" (ngSubmit)="saveChanges()"></form>
